import { Avatar } from '@lunary/ui-web/avatar'
import { Select } from '@lunary/ui-web/select'
import { Link } from '@tanstack/react-router'
import type { AdminUserResponseDto } from '@lunary/api-client'
import { ApiError } from '../../shared/api/client'
import { ROLES, ROLE_LABELS, formatDateTime, relativeSeen, roleLabel, sourceLabel } from './labels'
import { userTitle } from './identity'
import { useSetRole } from './queries'

export function UserRow({ item, isSelf }: { item: AdminUserResponseDto; isSelf: boolean }) {
  const setRole = useSetRole(item.id)
  const { title, details } = userTitle(item)

  return (
    <tr>
      <td>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Avatar src={item.avatar_url} name={title.replace('@', '')} size={32} />
          <Link to="/users/$userId" params={{ userId: item.id }} className="user-link">
            {title}
          </Link>
        </div>
        {details.length > 0 && <div className="muted user-ids">{details.join(' · ')}</div>}
        {item.blocked_at && <span className="badge danger">Заблокирован</span>}
      </td>
      <td>
        <Select
          size="sm"
          sheet="never"
          aria-label={`Роль: ${roleLabel(item.role)}`}
          value={item.role}
          disabled={setRole.isPending || isSelf}
          options={ROLES.map((r) => ({ value: r, label: ROLE_LABELS[r] }))}
          onChange={(v) => {
            const next = ROLES.find((r) => r === v)
            if (next && next !== item.role) setRole.mutate(next)
          }}
        />
        {setRole.error && (
          <div className="error-box" role="alert">
            {setRole.error instanceof ApiError ? setRole.error.message : 'Не удалось сменить роль'}
          </div>
        )}
      </td>
      <td>{sourceLabel(item.signup_source)}</td>
      <td>
        <div title={formatDateTime(item.last_seen_at)}>{relativeSeen(item.last_seen_at)}</div>
        <div className="muted">{sourceLabel(item.last_seen_source)}</div>
      </td>
      <td>{formatDateTime(item.created_at)}</td>
    </tr>
  )
}
